import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from 'common/components/Elements/Button/Button';
import ColorPicker from 'common/components/Elements/ColorPicker/ColorPicker';
import InputCheckboxGroup from 'common/components/Elements/Form/InputCheckboxGroup/InputCheckboxGroup';
import React from 'react';
import type { ResiduesGroup, SelectedColorScheme } from 'sequenceAnalyser/utilities/colors';

import classes from './ColorsResidues.style';

interface ComponentProps {
  colors: SelectedColorScheme;
  onResidueVisibilityToggle: (residue: string) => void;
  onResiduesVisibilityToggle: (residues: string[], show: boolean) => void;
  colorsResiduesGroups: ResiduesGroup[];
}

function ColorsResidues({
  colors, onResidueVisibilityToggle, onResiduesVisibilityToggle, colorsResiduesGroups,
}: ComponentProps) {
  return (
    <Grid container>
      <Grid item xs={6}>
        <Box>
          <Box id="colorsResidues">
            {Object.keys(colors.infos).map((k) => {
              const { color, show, name } = colors.infos[k];

              return (
                <Box key={k} sx={classes.residueButton}>
                  <Button
                    small
                    action={show ? 'secondary' : 'tertiary'}
                    onClick={() => onResidueVisibilityToggle(k)}
                    title={name}
                    fullWidth
                  >
                    {k}
                    {color && show && (
                      <Box sx={classes.residueButtonColor}>
                        <ColorPicker color={color} />
                      </Box>
                    )}
                  </Button>
                </Box>
              );
            })}
          </Box>
          <Box>
            <Button
              small
              action="tertiary"
              onClick={() => onResiduesVisibilityToggle(Object.keys(colors.infos), true)}
            >
              All
            </Button>
            <Button
              small
              action="tertiary"
              onClick={() => onResiduesVisibilityToggle(Object.keys(colors.infos), false)}
            >
              None
            </Button>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={6}>
        <InputCheckboxGroup
          options={colorsResiduesGroups.map((group) => (
            { value: group.name, label: `${group.name} (${group.residues.join(', ')})` }
          ))}
          values={
            colorsResiduesGroups
              .filter((group) => group.residues.reduce<boolean>((acc, r) => (
                acc === false ? false : colors.infos[r].show
              ), true))
              .map((group) => group.name)
          }
          onChange={(value, checked) => {
            const group = colorsResiduesGroups.find((g) => g.name === value);
            onResiduesVisibilityToggle(group ? group.residues : [], !checked);
          }}
        />
      </Grid>
    </Grid>
  );
}

export default ColorsResidues;
